'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { fromJS } from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import DetailsPanelItems from '../constants/DetailsPanelItems';
import { getChildDestinationId, getChildTemplatePath, getDestinationIdForGoodNotInPack, getTemplatePathForGoodNotInPack } from '../utils/managePurchases/utils';
export default function purchasedGoodReducer(purchasedGood, action) {
  switch (action.type) {
    case ActionTypes.GOOD_USAGE_INFO_RECEIVED:
      return purchasedGood.merge({
        assetsWhereGoodInUse: fromJS(action.payload.assetsWhereGoodInUse)
      });

    case ActionTypes.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS:
      return purchasedGood.merge(_defineProperty({}, DetailsPanelItems.REVIEW, action.payload.review));

    case ActionTypes.TOGGLE_PURCHASED_PACK:
      return purchasedGood.merge({
        showChildren: !purchasedGood.get('showChildren')
      });

    case ActionTypes.POLLING_GOOD_INFO_RECEIVED:
      {
        var goodDeliverInfo = action.payload.goodDeliverInfo;

        if (purchasedGood.get('parentId')) {
          var child = purchasedGood.toJS();
          return purchasedGood.merge({
            destinationId: getChildDestinationId(goodDeliverInfo, child),
            templatePath: getChildTemplatePath(goodDeliverInfo, child)
          });
        }

        return purchasedGood.merge({
          destinationId: getDestinationIdForGoodNotInPack(goodDeliverInfo),
          newVersionAvailable: false,
          templatePath: getTemplatePathForGoodNotInPack(goodDeliverInfo)
        });
      }

    default:
      return purchasedGood;
  }
}